interface ActionSheetProps {
    children: React.ReactNode,
    show: boolean,
    toggleShow(show: boolean): void
}
export default function ActionSheet({
    children,
    show,
    toggleShow
}: ActionSheetProps) {

    return (
        <div
            hidden={!show}
        >
            <div
                className="fixed inset-0 bg-gray-800 bg-opacity-70 flex items-end overflow-hidden z-30"
                onClick={() => { toggleShow(false) }}
            >
                <div
                    className="h-4/6 bg-white w-full rounded-t-xl"
                    onClick={(e) => { e.stopPropagation() }}
                >
                    {children}
                </div>
            </div>
        </div>
    )

}
